import React from 'react'
import CopyButton from '../../../ui/CopyButton/CopyButton'
import { useSiteToast } from '../../../ui/SiteToast/SiteToastContext'

function ShortLinkCell({ shortUrl }) {
  const { showSiteToast } = useSiteToast()

  if (!shortUrl) {
    return <span>—</span>
  }

  const handleCopied = () => {
    showSiteToast({
      message: 'Коротке посилання скопійовано',
      icon: 'check',
      iconWeight: 'regular',
      theme: 'default',
    })
  }

  return (
    <div className="MarketingLinks-ShortLinkCell">
      <span className="MarketingLinks-ShortLinkText" title={shortUrl}>
        {shortUrl}
      </span>
      <CopyButton value={shortUrl} ariaLabel="Скопіювати коротке посилання" onCopied={handleCopied} />
    </div>
  )
}

export default ShortLinkCell
